export interface Movie {
  id: string;
  title: string;
  year: number;
  region: string;
  categoryId: string;
  categoryIds: string[];
  tags: string[];
  synopsis: string;
  director: string;
  cast: string[];
  duration: number;
  rating: number;
  views: number;
  favorites: number;
  featured: boolean;
  cover: string;
}

export const movies: Movie[] = [
  {
    id: "neon-night",
    title: "霓虹夜色",
    year: 2019,
    region: "香港",
    categoryId: "urban",
    categoryIds: ["urban", "thriller"],
    tags: ["都市", "情欲", "悬疑"],
    synopsis: "霓虹闪烁的深夜街头，一名酒吧歌手与神秘男子相遇，一场关于欲望与秘密的周旋悄然展开。当往事的真相逐渐浮现，她必须在沉沦与清醒之间做出抉择。",
    director: "陈国昌",
    cast: ["苏曼琪", "林耀阳", "何嘉欣"],
    duration: 104,
    rating: 8.2,
    views: 1284000,
    favorites: 8620,
    featured: true,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20an%20elegant%20woman%20in%20a%20vintage%20evening%20dress%20under%20glowing%20neon%20city%20lights%20at%20night%20dramatic%20deep%20red%20and%20warm%20amber%20cinematic%20lighting%20atmospheric%20rain%20haze%20elegant%20artistic%20composition%20subtle%20film%20grain%20texture%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-01&orientation=portrait",
  },
  {
    id: "midnight-rose",
    title: "午夜玫瑰",
    year: 2021,
    region: "台湾",
    categoryId: "urban",
    categoryIds: ["urban", "crime"],
    tags: ["都市", "罪案", "情感"],
    synopsis: "一间深夜营业的爵士酒吧里，玫瑰与谎言同时绽放。女调酒师的出现打乱了一名落魄警探的卧底计划，两人在互相试探中越陷越深。",
    director: "高志远",
    cast: ["叶诗涵", "吴立言", "郑俊杰"],
    duration: 112,
    rating: 7.9,
    views: 986000,
    favorites: 6420,
    featured: true,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20an%20elegant%20woman%20sitting%20by%20a%20rainy%20window%20at%20midnight%20warm%20lamp%20light%20dramatic%20deep%20red%20and%20amber%20tones%20atmospheric%20shadows%20elegant%20artistic%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-02&orientation=portrait",
  },
  {
    id: "city-drift",
    title: "都市浮生",
    year: 2018,
    region: "内地",
    categoryId: "urban",
    categoryIds: ["urban", "thriller"],
    tags: ["都市", "悬疑", "情感"],
    synopsis: "一家濒临倒闭的广告公司里，几位都市男女在名利与情感的漩涡中浮沉。当一桩意外揭开彼此隐藏的秘密，平静的办公室生活彻底改写。",
    director: "李文君",
    cast: ["周雨桐", "孙嘉明", "刘思远"],
    duration: 98,
    rating: 7.4,
    views: 745000,
    favorites: 4180,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20stylish%20couple%20silhouetted%20against%20a%20dim%20luxury%20hotel%20lobby%20at%20night%20dramatic%20deep%20red%20and%20warm%20amber%20lighting%20atmospheric%20shadows%20elegant%20artistic%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-03&orientation=portrait",
  },
  {
    id: "glass-desire",
    title: "玻璃迷情",
    year: 2022,
    region: "香港",
    categoryId: "urban",
    categoryIds: ["urban", "fantasy"],
    tags: ["都市", "奇幻", "情迷"],
    synopsis: "一名建筑设计师搬进全玻璃幕墙的高层公寓，却在反光中看见另一个自己的倒影。真实与幻象交错之间，她开始分不清心底的渴望究竟属于谁。",
    director: "黄伟豪",
    cast: ["林嘉欣", "陈家俊", "梁咏诗"],
    duration: 106,
    rating: 7.6,
    views: 612000,
    favorites: 3980,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20modern%20glass%20building%20interior%20with%20a%20lone%20elegant%20figure%20moody%20crimson%20reflections%20dramatic%20deep%20red%20and%20warm%20amber%20lighting%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-04&orientation=portrait",
  },
  {
    id: "rouge-tribulation",
    title: "红颜劫",
    year: 2017,
    region: "内地",
    categoryId: "costume",
    categoryIds: ["costume", "classic"],
    tags: ["古装", "宫廷", "情感"],
    synopsis: "深宫烛影摇曳，一名入宫为婢的女子被卷入后宫的权谋与情欲。她凭借聪慧步步为营，却在权力与真心之间付出沉重代价。",
    director: "许文远",
    cast: ["白若薇", "慕容清", "赵子昂"],
    duration: 118,
    rating: 8.0,
    views: 1092000,
    favorites: 7210,
    featured: true,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20graceful%20woman%20in%20traditional%20chinese%20hanfu%20robes%20standing%20in%20an%20ancient%20candlelit%20palace%20hall%20deep%20red%20silk%20warm%20amber%20lighting%20dramatic%20shadows%20elegant%20artistic%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-05&orientation=portrait",
  },
  {
    id: "immortal-painting",
    title: "画中仙",
    year: 2015,
    region: "香港",
    categoryId: "costume",
    categoryIds: ["costume", "fantasy"],
    tags: ["古装", "奇幻", "传说"],
    synopsis: "一幅流传百年的古画中住着一位神秘女子，唯有有缘之人在深夜才能见到她。书生与她相识相恋，却发现画中的秘密远比他想象得更加离奇。",
    director: "何锦荣",
    cast: ["温碧瑶", "程亦凡", "苏婉清"],
    duration: 96,
    rating: 7.3,
    views: 538000,
    favorites: 3620,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20mysterious%20woman%20emerging%20from%20a%20classical%20chinese%20ink%20painting%20with%20flowing%20silk%20robes%20warm%20amber%20candlelight%20deep%20red%20accents%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-06&orientation=portrait",
  },
  {
    id: "golden-dream",
    title: "金瓶旧梦",
    year: 2016,
    region: "台湾",
    categoryId: "costume",
    categoryIds: ["costume", "classic"],
    tags: ["古装", "经典", "情感"],
    synopsis: "旧时庭院深处，一段不为世俗所容的情感在暗流中滋长。华服锦缎之下，人心比宅院更深，欲望与命运交织成一曲旧梦。",
    director: "蔡明堂",
    cast: ["吴映雪", "林国栋", "黄丽珠"],
    duration: 122,
    rating: 7.7,
    views: 664000,
    favorites: 4050,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20an%20ancient%20chinese%20courtyard%20at%20dusk%20with%20an%20elegant%20figure%20in%20embroidered%20silk%20robes%20warm%20lantern%20light%20deep%20red%20and%20amber%20tones%20dramatic%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-07&orientation=portrait",
  },
  {
    id: "long-night-spring",
    title: "长夜春色",
    year: 2020,
    region: "内地",
    categoryId: "costume",
    categoryIds: ["costume", "crime"],
    tags: ["古装", "悬疑", "罪案"],
    synopsis: "民国年间的深宅里，一场婚礼揭开连环谜案。新娘发现这户人家的每一个房间都藏着秘密，而她的命运早已被人精心安排。",
    director: "孙立群",
    cast: ["江宁儿", "张慕白", "李秀娥"],
    duration: 110,
    rating: 7.8,
    views: 812000,
    favorites: 5240,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20traditional%20chinese%20bedroom%20at%20night%20with%20soft%20candlelight%20and%20flowing%20silk%20curtains%20deep%20red%20and%20warm%20amber%20tones%20atmospheric%20shadows%20elegant%20artistic%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-08&orientation=portrait",
  },
  {
    id: "undercurrent",
    title: "暗涌",
    year: 2023,
    region: "香港",
    categoryId: "thriller",
    categoryIds: ["thriller", "crime"],
    tags: ["悬疑", "罪案", "都市"],
    synopsis: "一桩离奇失踪案牵出城市地下的庞大网络，女记者深入调查，却发现线索指向自己最不愿面对的过去。真相如同暗涌，平静表面下暗藏杀机。",
    director: "冯振宇",
    cast: ["邓紫琳", "周天成", "马国明"],
    duration: 108,
    rating: 8.4,
    views: 1420000,
    favorites: 9860,
    featured: true,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20shadowy%20urban%20alley%20at%20night%20with%20a%20lone%20mysterious%20figure%20dramatic%20deep%20red%20and%20warm%20amber%20lighting%20rain%20and%20fog%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-09&orientation=portrait",
  },
  {
    id: "peeper-confession",
    title: "偷窥者的告白",
    year: 2021,
    region: "台湾",
    categoryId: "thriller",
    categoryIds: ["thriller", "urban"],
    tags: ["悬疑", "都市", "禁忌"],
    synopsis: "对窗女孩日复一日的生活被一名神秘邻居暗中记录。当她终于发现那双注视的眼睛，一场关于信任与恐惧的心理博弈拉开序幕。",
    director: "吴念真",
    cast: ["林依晨", "陈柏霖", "杨谨华"],
    duration: 102,
    rating: 7.9,
    views: 903000,
    favorites: 6720,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20dim%20apartment%20window%20at%20night%20behind%20sheer%20curtains%20moody%20suspenseful%20deep%20red%20and%20warm%20amber%20lighting%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-10&orientation=portrait",
  },
  {
    id: "mystery-apartment",
    title: "谜情公寓",
    year: 2019,
    region: "内地",
    categoryId: "thriller",
    categoryIds: ["thriller", "fantasy"],
    tags: ["悬疑", "奇幻", "禁忌"],
    synopsis: "一名租客搬进老旧公寓的第一晚，就听见隔壁传来重复的脚步声。随着调查深入，他发现这栋楼里的住户似乎都活在同一个夜晚。",
    director: "郑少东",
    cast: ["许清清", "赵文卓", "刘丹"],
    duration: 94,
    rating: 7.5,
    views: 723000,
    favorites: 4560,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20mysterious%20dim%20apartment%20corridor%20with%20dramatic%20red%20and%20amber%20light%20and%20long%20shadows%20suspenseful%20atmospheric%20elegant%20artistic%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-11&orientation=portrait",
  },
  {
    id: "silent-neighbor",
    title: "沉默的邻居",
    year: 2022,
    region: "香港",
    categoryId: "thriller",
    categoryIds: ["thriller", "crime"],
    tags: ["悬疑", "罪案", "都市"],
    synopsis: "安静的小区里，新搬来的住户从不与任何人说话。直到一场停电之夜，楼道里的秘密被彻底揭开，所有人都成了嫌疑人。",
    director: "陈家驹",
    cast: ["蔡卓妍", "余文乐", "何超仪"],
    duration: 100,
    rating: 7.6,
    views: 668000,
    favorites: 4310,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20quiet%20suburban%20doorway%20at%20night%20under%20a%20single%20warm%20lamp%20moody%20suspenseful%20deep%20red%20and%20amber%20atmosphere%20dramatic%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-12&orientation=portrait",
  },
  {
    id: "old-shanghai-love",
    title: "旧上海之恋",
    year: 1995,
    region: "香港",
    categoryId: "classic",
    categoryIds: ["classic", "costume"],
    tags: ["经典", "民国", "情感"],
    synopsis: "上世纪三十年代的上海滩，一名歌女与年轻商人在舞厅相识。乱世浮沉，两人在灯红酒绿中相爱相守，却终究难以抵挡时代洪流。",
    director: "关锦鸿",
    cast: ["梅艳芳", "张国荣", "刘嘉玲"],
    duration: 126,
    rating: 8.6,
    views: 864000,
    favorites: 6280,
    featured: true,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20vintage%201930s%20shanghai%20ballroom%20with%20elegant%20figures%20in%20retro%20qipao%20dramatic%20golden%20amber%20light%20and%20deep%20red%20accents%20nostalgic%20atmospheric%20shadows%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-13&orientation=portrait",
  },
  {
    id: "neon-old-town",
    title: "灯红酒绿",
    year: 1992,
    region: "香港",
    categoryId: "classic",
    categoryIds: ["classic", "crime"],
    tags: ["经典", "江湖", "罪案"],
    synopsis: "老香港的夜总会上，霓虹与人心同样迷离。一名舞小姐卷入帮派争斗，在刀光与温柔之间艰难求生。这是一段属于旧时代的光影记忆。",
    director: "王天林",
    cast: ["叶玉卿", "任达华", "吴家丽"],
    duration: 120,
    rating: 8.1,
    views: 792000,
    favorites: 5540,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20retro%20nightclub%20scene%20from%20old%20hong%20kong%20with%20neon%20signs%20and%20elegant%20silhouettes%20warm%20amber%20and%20crimson%20glow%20nostalgic%20film%20grain%20atmospheric%20shadows%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-14&orientation=portrait",
  },
  {
    id: "spring-old-dream",
    title: "春光旧梦",
    year: 1998,
    region: "台湾",
    categoryId: "classic",
    categoryIds: ["classic", "urban"],
    tags: ["经典", "年代", "情感"],
    synopsis: "九十年代的台北街头，一段青梅竹马的感情在岁月里渐渐走散。多年后重逢，两人都已在各自的生活里改变了模样。",
    director: "侯孝贤",
    cast: ["舒淇", "黄舒骏", "杨贵媚"],
    duration: 116,
    rating: 8.3,
    views: 705000,
    favorites: 4920,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20nostalgic%201990s%20taiwanese%20street%20at%20dusk%20with%20vintage%20cars%20warm%20amber%20sunset%20and%20deep%20red%20tones%20retro%20film%20grain%20atmospheric%20shadows%20elegant%20composition%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-15&orientation=portrait",
  },
  {
    id: "midnight-song",
    title: "夜半歌声",
    year: 1990,
    region: "内地",
    categoryId: "classic",
    categoryIds: ["classic", "thriller"],
    tags: ["经典", "悬疑", "年代"],
    synopsis: "一座荒废的老戏院每逢午夜便传出歌声。年轻演员重返剧院，试图解开多年前一桩悲剧的真相，却在镜中看见了自己的前世。",
    director: "于仁泰",
    cast: ["张国荣", "吴倩莲", "黄磊"],
    duration: 114,
    rating: 8.2,
    views: 688000,
    favorites: 4610,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20vintage%20theatre%20stage%20with%20dramatic%20spotlight%20and%20deep%20red%20velvet%20curtains%20nostalgic%20warm%20amber%20lighting%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-16&orientation=portrait",
  },
  {
    id: "casino-past",
    title: "赌城往事",
    year: 2014,
    region: "香港",
    categoryId: "crime",
    categoryIds: ["crime", "classic"],
    tags: ["江湖", "罪案", "情感"],
    synopsis: "赌场贵宾厅里，一名荷官与赌徒之间产生了微妙的牵绊。当一局关乎生死的赌注摊开，爱情、忠义与贪婪同时被推向极限。",
    director: "杜琪峰",
    cast: ["刘德华", "古天乐", "郑秀文"],
    duration: 124,
    rating: 8.0,
    views: 968000,
    favorites: 7130,
    featured: true,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20smoky%20casino%20table%20at%20night%20with%20dramatic%20deep%20red%20and%20warm%20amber%20lighting%20and%20playing%20cards%20moody%20crime%20film%20atmosphere%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-17&orientation=portrait",
  },
  {
    id: "dangerous-deal",
    title: "危险交易",
    year: 2018,
    region: "内地",
    categoryId: "crime",
    categoryIds: ["crime", "thriller"],
    tags: ["罪案", "悬疑", "江湖"],
    synopsis: "一次看似普通的交易，将三个互不相识的人卷进同一场阴谋。仓库的灯光忽明忽暗，每个人都在盘算着如何活着离开。",
    director: "曹保平",
    cast: ["段奕宏", "余男", "王砚辉"],
    duration: 118,
    rating: 8.1,
    views: 856000,
    favorites: 5890,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20dark%20warehouse%20at%20night%20with%20silhouetted%20figures%20dramatic%20deep%20red%20and%20warm%20amber%20light%20moody%20crime%20film%20atmosphere%20atmospheric%20shadows%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-18&orientation=portrait",
  },
  {
    id: "gangster-lover",
    title: "道上情人",
    year: 2016,
    region: "台湾",
    categoryId: "crime",
    categoryIds: ["crime", "urban"],
    tags: ["江湖", "都市", "情感"],
    synopsis: "帮派老大的女人与保镖在逃亡途中渐生情愫，理智告诉他们都该放手，可漫天夜雨里，谁也无法转身离开。",
    director: "钮承泽",
    cast: ["张榕容", "阮经天", "凤小岳"],
    duration: 106,
    rating: 7.7,
    views: 742000,
    favorites: 4760,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20rain%20soaked%20city%20street%20at%20night%20with%20a%20stylish%20figure%20in%20a%20coat%20dramatic%20crimson%20and%20amber%20light%20moody%20crime%20drama%20atmospheric%20shadows%20elegant%20composition%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-19&orientation=portrait",
  },
  {
    id: "bloody-jianghu",
    title: "血色江湖",
    year: 2013,
    region: "香港",
    categoryId: "crime",
    categoryIds: ["crime", "costume"],
    tags: ["江湖", "罪案", "情感"],
    synopsis: "一间老酒楼曾是各方势力交接的地盘，一盏盏红灯笼下藏着无数恩怨。退隐江湖的男人为了心爱的女人，被迫重新入局。",
    director: "麦兆辉",
    cast: ["梁家辉", "张家辉", "林熙蕾"],
    duration: 122,
    rating: 7.9,
    views: 712000,
    favorites: 4430,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20dim%20chinese%20restaurant%20at%20night%20with%20dramatic%20red%20lanterns%20and%20silhouetted%20figures%20moody%20crime%20film%20atmosphere%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-20&orientation=portrait",
  },
  {
    id: "phantom-night",
    title: "幻夜魅影",
    year: 2020,
    region: "内地",
    categoryId: "fantasy",
    categoryIds: ["fantasy", "urban"],
    tags: ["奇幻", "都市", "传说"],
    synopsis: "一名失眠的摄影师在天台遇见只在午夜出现的女子，她的身影永远无法被镜头捕捉。为了留住她，他开始追问这段邂逅究竟是梦还是现实。",
    director: "乌尔善",
    cast: ["周迅", "陈坤", "杨颖"],
    duration: 108,
    rating: 7.6,
    views: 634000,
    favorites: 4120,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20mystical%20moonlit%20rooftop%20with%20an%20elegant%20figure%20in%20flowing%20robes%20deep%20red%20and%20amber%20magical%20glow%20fantasy%20atmosphere%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20high%20detail&width=600&height=900&seq=movie-21&orientation=portrait",
  },
  {
    id: "thousand-year-fox",
    title: "千年狐缘",
    year: 2019,
    region: "台湾",
    categoryId: "fantasy",
    categoryIds: ["fantasy", "costume"],
    tags: ["奇幻", "古装", "传说"],
    synopsis: "深山里修炼千年的狐妖化作人形，与迷路的书生结下一段尘缘。人妖殊途的宿命之下，她愿意为他舍弃全部修为。",
    director: "程小东",
    cast: ["刘亦菲", "冯绍峰", "郭碧婷"],
    duration: 114,
    rating: 7.8,
    views: 726000,
    favorites: 4980,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20mystical%20ancient%20forest%20at%20night%20with%20soft%20glowing%20lights%20and%20an%20elegant%20figure%20in%20silk%20robes%20warm%20amber%20and%20deep%20red%20fantasy%20atmospheric%20shadows%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-22&orientation=portrait",
  },
  {
    id: "enchantress-biography",
    title: "妖姬传",
    year: 2021,
    region: "香港",
    categoryId: "fantasy",
    categoryIds: ["fantasy", "classic"],
    tags: ["奇幻", "古装", "传说"],
    synopsis: "古宫中流传着一位绝世妖姬的传说，见过她的人无一例外地沉沦。当新的宫女踏入那间偏殿，尘封百年的诅咒再次被唤醒。",
    director: "徐克",
    cast: ["范冰冰", "黄晓明", "杨颖"],
    duration: 120,
    rating: 7.5,
    views: 588000,
    favorites: 3740,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20an%20ornate%20ancient%20palace%20with%20warm%20candlelight%20and%20an%20elegant%20figure%20in%20dramatic%20silk%20robes%20deep%20red%20fantasy%20atmosphere%20atmospheric%20shadows%20elegant%20composition%20subtle%20film%20grain%20tasteful%20non%20explicit%20high%20detail&width=600&height=900&seq=movie-23&orientation=portrait",
  },
  {
    id: "moonlight-spell",
    title: "月光魔咒",
    year: 2022,
    region: "内地",
    categoryId: "fantasy",
    categoryIds: ["fantasy", "thriller"],
    tags: ["奇幻", "悬疑", "传说"],
    synopsis: "每逢满月，海滨小镇都会有人失踪。一名调查记者发现所有线索都指向一位在月下独舞的神秘女子，而她自己似乎正是诅咒的一部分。",
    director: "陈思诚",
    cast: ["倪妮", "陈飞宇", "周冬雨"],
    duration: 104,
    rating: 7.4,
    views: 552000,
    favorites: 3480,
    featured: false,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20moody%20film%20poster%20artwork%20of%20a%20moonlit%20sea%20shore%20at%20night%20with%20an%20elegant%20figure%20in%20a%20flowing%20gown%20warm%20amber%20and%20deep%20red%20magical%20glow%20fantasy%20atmospheric%20shadows%20subtle%20film%20grain%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=600&height=900&seq=movie-24&orientation=portrait",
  },
];

export const heroSlides: string[] = [
  "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20rain%20soaked%20neon%20city%20street%20at%20night%20with%20elegant%20silhouettes%20dramatic%20deep%20red%20and%20warm%20amber%20lighting%20atmospheric%20haze%20luxury%20film%20aesthetic%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=1920&height=800&seq=hero-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20an%20ancient%20candlelit%20chinese%20palace%20hall%20with%20deep%20red%20silk%20curtains%20and%20warm%20amber%20light%20dramatic%20shadows%20elegant%20atmospheric%20film%20aesthetic%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=1920&height=800&seq=hero-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20moody%20vintage%20theatre%20with%20deep%20red%20velvet%20curtains%20and%20warm%20amber%20spotlight%20nostalgic%20atmosphere%20film%20grain%20elegant%20composition%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=1920&height=800&seq=hero-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20luxurious%20dim%20lounge%20interior%20at%20night%20with%20warm%20amber%20lamps%20deep%20red%20accents%20and%20elegant%20coupled%20silhouettes%20atmospheric%20film%20aesthetic%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=1920&height=800&seq=hero-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20mystical%20moonlit%20rooftop%20with%20flowing%20silk%20and%20warm%20amber%20magical%20glow%20deep%20red%20fantasy%20atmosphere%20elegant%20cinematic%20composition%20tasteful%20non%20explicit%20dark%20warm%20background%20high%20detail&width=1920&height=800&seq=hero-05&orientation=landscape",
];